import { render } from "./page-dashboard.vue?vue&type=template&id=0f7f7c29"
import script from "./page-dashboard.vue?vue&type=script&lang=js"
export * from "./page-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__